// pages/main/products/details.tsx
import { productService } from '@cabukaka/services';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PageHeader from '../../../components/ui/PageHeader';
import ProductDetails from '../../../components/sections/product/ProductDetails';
import SimilarProducts from '../../../components/sections/product/SimilarProducts';
import { Product } from '@cabukaka/types';
import { NotFoundContent } from '../../../components/ui/NotFoundContent';

export default function ProductPage() {
    const { slug } = useParams();
    const [product, setProduct] = useState<Product | null>(null);
    const [similarProducts, setSimilarProducts] = useState<Product[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            if (!slug) return;

            try {
                const productData = await productService.getProductBySlug(slug);
                setProduct(productData);


                if (productData) {
                    const similarData = await productService.getProductByCategorySlug(productData.categoryId || '');
                    const filtered = (similarData?.data || []).filter(p => p.id !== productData.id).slice(0, 6);
                    setSimilarProducts(filtered);
                }
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [slug]);

    if (loading) {
        return (
            <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500"></div>
            </div>
        );
    }

    if (!product) {
        return (
            <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white flex items-center justify-center">
                <NotFoundContent
                    iconName="Package"
                    title="Produit non trouvé"
                    description="Le produit que vous recherchez n'existe pas ou a été supprimé."
                    actionLabel="Voir tous les produits"
                    actionHref="/products"
                />
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
            <PageHeader
                breadcrumb={[
                    { label: "Produits", href: "/produits" },
                    { label: product.name, href: "" }
                ]}
            />

            <ProductDetails product={product} />

            <SimilarProducts product={product} products={similarProducts} />
        </div>
    );
}